/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Unsubscribe } from "firebase/auth";
import { query, limit, orderBy, collection, onSnapshot, getFirestore } from "firebase/firestore";
import { parentsFirebase } from "app/Auth";
import { AppDispatch, RootState } from "app/store";
import { ChatRoomMessage } from "features/user/types";
import { actions, selectAllChatRooms } from "features/user/slice";

export const useSubscribe = () => {
  const dispatch = useDispatch<AppDispatch>();
  const chatRooms = useSelector(selectAllChatRooms);
  const [chatMessageSubscribes, setChatMessageSubscribes] = useState<
    { chatRoomId: string; unsubscribe: Unsubscribe }[]
  >([]);
  const active = useSelector((state: RootState) => state.user.active);

  const subscribeUserChatRoomMessage = (chatRoomId: string, uid: string) => {
    const now = dayjs().format("YYYY-MM-DDTHH:mm:ssZ");
    dispatch(
      actions.updateChatRoomMessageLastSyncAt({
        chatRoomId: chatRoomId,
        uid,
        lastMessageSyncAt: now,
      }),
    );

    const db = getFirestore(parentsFirebase);
    const initialMessages: ChatRoomMessage[] = [];
    // 常に20件フェッチ
    const messages = query(
      collection(db, "rooms", chatRoomId, "messages"),
      orderBy("created_at", "desc"),
      limit(20),
    );

    let initial = true;
    const unsubscribe = onSnapshot(
      messages,
      (snapshot) => {
        if (initial) {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              initialMessages.push(change.doc.data() as ChatRoomMessage);
              if (change.newIndex === snapshot.size - 1) {
                dispatch(
                  actions.bulkInsertChatRoomMessage({
                    uid,
                    messages: initialMessages,
                  }),
                );
              }
            }
          });
          initial = false;
        } else {
          snapshot.docChanges().forEach((change) => {
            switch (change.type) {
              case "added":
                dispatch(
                  actions.insertChatRoomMessage({
                    uid,
                    message: change.doc.data() as ChatRoomMessage,
                  }),
                );
                break;
            }
          });
        }
      },
      (error) => {
        console.error(error);
      },
    );

    return { chatRoomId, unsubscribe };
  };

  useEffect(() => {
    const newUserChatSubscribes = chatRooms.map((chatRoom) =>
      subscribeUserChatRoomMessage(chatRoom.id, chatRoom.uid),
    );
    setChatMessageSubscribes(newUserChatSubscribes);
  }, [chatRooms]);

  useEffect(() => {
    return () => {
      chatMessageSubscribes.map((chatMessageSubscribe) => chatMessageSubscribe.unsubscribe());
      setChatMessageSubscribes([]);
    };
  }, [active]);
};
